import BaseView from './base';

export default class MatrixFlipColumnView extends BaseView {
    constructor(matrix) {
        super(matrix, matrix.rows, matrix.columns);
    }

    set(rowIndex, columnIndex, value) {
        this.matrix.set(rowIndex, this.columns - columnIndex - 1, value);
        return this;
    }

    get(rowIndex, columnIndex) {
        return this.matrix.get(rowIndex, this.columns - columnIndex - 1);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-kernel/~/ml-matrix/src/views/flipColumn.js
// module id = 165
// module chunks = 0